'use es6';

import { combineReducers } from 'redux';
import confirmToLogin from './confirmToLogin';
import twoFactorAuth from './twoFactorAuth';
import twoFactorRecovery from './twoFactorRecovery';
import loginRequirement from './loginRequirement';
export default combineReducers({
  confirmToLogin,
  twoFactorAuth,
  twoFactorRecovery,
  loginRequirement
});